import { useEffect, useState } from "react";

interface UseImageLoaderProps {
  imgSrc: string;
  webp: string;
}

const useImageLoader = ({ imgSrc, webp }: UseImageLoaderProps) => {
  const [imageSrc, setImageSrc] = useState<string>("");
  const [webpSrc, setWebpSrc] = useState<string>("");

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImageSrc(imgSrc);
    };
    img.src = imgSrc;
    const webpInstance = new Image();
    webpInstance.onload = () => setWebpSrc(webp);
    webpInstance.src = webp;
  }, [imgSrc, webp]);

  return { imageSrc, webpSrc };
};

export default useImageLoader;
